/*
Для использования методов нужно иметь в шаблоне компоненты RequestExecutorSelectionWindow для открытия окон выбора исполнителя,
a также параметр компонента executorChangeAvailable
 */
export const requestExecutorActions = {
  methods: {
    showProposedExecutors: function () {
      if (this.checkRequestBeforeExecutorsProposal() && this.executorChangeAvailable) {
        this.$refs.executorSelector.select()
          .then(executorSelection => {
            this.request.proposedExecutorObject = executorSelection
          })
      }
    },
    showProposedReinforcementExecutors: function () {
      if (this.checkRequestBeforeExecutorsProposal() && this.reinforcementExecutorChangeAvailable) {
        this.$refs.reinforcementExecutorSelector.select()
          .then(reinforcementExecutorSelection => {
            reinforcementExecutorSelection.executors = reinforcementExecutorSelection.executors.map(brigade => {
              return {
                brigadeId: brigade.brigadeId,
                brigadeName: brigade.brigadeName,
                fullName: this.getBrigadeName(brigade, false),
                employees: brigade.employees,
                workAreas: brigade.workAreas,
                workShift: brigade.workShift
              }
            })
            this.request.proposedReinforcementExecutorObject = reinforcementExecutorSelection
          })
      }
    },
    checkRequestBeforeExecutorsProposal: function () {
      if (!this.request.requestType || !this.request.requestPriority) {
        this.$q.notify({
          type: 'negative',
          message: 'Для просмотра предложенных исполнителей нужно заполнить поля: "Тип заявки", "Приоритет заявки".',
          progress: true,
          timeout: 8000
        })

        return false
      }
      return true
    },
    clearReinforcementExecutors: function () {
      if (this.checkRequestBeforeExecutorsProposal() && this.reinforcementExecutorChangeAvailable) {
        this.request.proposedReinforcementExecutorObject = this.$refs.reinforcementExecutorSelector.getClearedReinforcementExecutorObject()
      }
    },
    getBrigadeName: function (brigade, includeWorkAreas) {
      return getBrigadeName(brigade, includeWorkAreas)
    },
    getEmployeeName: function (employee) {
      return getEmployeeName(employee)
    }
  }
}

// TO DO: replace to helpers.js
export function getBrigadeName (brigade, includeWorkAreas = true) {
  let name = ''
  if (brigade) {
    if (includeWorkAreas && brigade.workAreas && brigade.workAreas.length) {
      const workAreasNames = []
      brigade.workAreas.forEach(workArea => {
        if (workArea.name) {
          workAreasNames.push(workArea.name)
        } else if (typeof workArea === 'string') {
          workAreasNames.push(workArea)
        }
      })
      if (workAreasNames.length) {
        name = workAreasNames.join(' ') + ' '
      }
    }

    if (brigade.guiName) {
      name += brigade.guiName
    } else {
      name += brigade.brigadeName ? brigade.brigadeName : brigade.name

      // TO DO: check employee names in brigadeName
      if (!brigade.contractor && brigade.employees) {
        name += ' (' + brigade.employees.map(employee => getEmployeeName(employee)).join(', ') + ')'
      }
    }
  }

  return name
}

export function getEmployeeName (employee) {
  if (employee.fio || employee.name) {
    let fio = employee.fio || employee.name
    if (!fio.includes('.')) {
      const [f, i, o] = fio.split(' ')
      fio = f
      if (i && i.length) {
        fio += ' ' + i[0] + '.'
        if (o && o.length) {
          fio += ' '
        }
      }
      if (o && o.length) {
        fio += o[0] + '.'
      }
    }
    return fio
  } else {
    return 'Сотрудник '
  }
}
